import { useCallback, useState } from "react";
import DateRangeCalendar from "src/components/input/DateRangePicker/components/DateRangeCalendar/DateRangeCalendar";
import type { DateRangeValue } from "src/components/input/DateRangePicker/DateRangePicker.types";
import type { TimeWindowRecentEntry } from "../../TimeWindow.recent.types";
import { urlTimeWindow } from "../../TimeWindow.urlSerialization";

interface TimeWindowCustomProps {
  value: DateRangeValue | undefined;
  setSelectedValue: (value: string) => void;
  pushRecent: (entry: TimeWindowRecentEntry) => void;
}

const TimeWindowCustom = ({
  value,
  setSelectedValue,
  pushRecent,
}: TimeWindowCustomProps) => {
  const [dateRange, setDateRange] = useState<DateRangeValue>(value || [null, null]);

  const onApply = useCallback(() => {
    const stringDateRange = urlTimeWindow.serializeDateRange(
      dateRange as [Date, Date]
    );

    pushRecent(stringDateRange);
    setSelectedValue(stringDateRange);
  }, [pushRecent, setSelectedValue, dateRange]);

  return (
    <DateRangeCalendar value={dateRange} onChange={setDateRange} onApply={onApply} />
  );
};

export default TimeWindowCustom;
